import React from "react";
import { Receivables } from "@mercoa/react";
import { useNavigate } from "react-router-dom";
import { useMercoaSession } from "@mercoa/react";

const ReceivablesTable = () => {
  const navigator = useNavigate();
  const session = useMercoaSession();

  const receivableStatuses = ["DRAFT", "APPROVED", "PAID"];

  return (
    <Receivables
      statuses={receivableStatuses}
      onSelectInvoice={(invoice) => {
        let entityId = session.entity.id;
        navigator(`receivableinvoice/${entityId}/${invoice.id}`);
      }}
    />
  );
};

export default ReceivablesTable;
